module.exports = __webpack_public_path__ + "img/heading-2.38ea6ed.svg";